export async function workforceRequest(url, body, signal) {
  const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.status) throw new Error(payload.message || 'Unable to complete the teacher attendance and salary request.');
  return payload;
}
